import type { Components } from '@mui/material/styles';

export const MuiSelect = (): Partial<Components> => {
  return {
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
          '&.Mui-disabled': {
            color: 'rgba(0,0,0,0.3)',
          },
        },
      },
    },
  };
};
